import { render, staticRenderFns } from "./task-wrapper.vue?vue&type=template&id=6749b0e1&"
import script from "./task-wrapper.vue?vue&type=script&lang=ts&"
export * from "./task-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./task-wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports